import React, { useEffect, useState } from "react";

const fetchBlobUrl = async (url) => {
  const res = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
  if (!res.ok) throw new Error("Image unavailable");
  return URL.createObjectURL(await res.blob());
};

export const openAuthImage = async (url) => {
  const win = window.open("", "_blank");
  try { if (win) win.location.href = await fetchBlobUrl(url); } catch { win?.close(); }
};

// <img> that sends the session in a header instead of the URL
export const AuthImage = ({ src, ...props }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  useEffect(() => {
    let url;
    let alive = true;
    fetchBlobUrl(src).then((u) => { url = u; if (alive) setBlobUrl(u); else URL.revokeObjectURL(u); }).catch(() => {});
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [src]);
  return blobUrl ? <img src={blobUrl} {...props} /> : <div className={`${props.className || ""} bg-slate-100 animate-pulse`} />;
};
